import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { PageContent } from "./PageContent";

/**
 * Generic route handler for Sanity `page` documents.
 * Connects URL slug(s) to `usePage(slug)` inside `PageContent`.
 */
export default function SanityPage() {
  const params = useParams();

  // Support both "/:slug" and "/ausbildung/:slug" (and any other nested route that uses :slug)
  const slug = useMemo(() => {
    const raw = params?.slug;
    if (!raw) return "";
    return String(raw).replace(/^\//, "");
  }, [params]);

  return (
    <PageContent
      slug={slug}
      fallbackTitle=""
      showHeroImage
      showGallery
      showBackButton
      hideFallbackWhileLoading
    />
  );
}

